import { render, staticRenderFns } from "./channel-cooperation.vue?vue&type=template&id=768adce6&"
import script from "./channel-cooperation.js?vue&type=script&lang=js&"
export * from "./channel-cooperation.js?vue&type=script&lang=js&"
import style0 from "./channel-cooperation.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports